// Layer 2 — agent leave (unavailability) — docs/real-estate/be/
// 10-api-reference.md §A9. `property_id` omitted or null applies the leave
// at every project; both times omitted or null means all day. Existing
// bookings inside the leave are never moved or cancelled by this.
import { request } from './http';

export function listLeave(agentId, { from_date, to_date } = {}) {
  return request({
    path: `/properties/agents/${agentId}/unavailability`,
    params: { from_date, to_date },
  });
}

// `body`: { unavailable_date, start_time?, end_time?, property_id?, reason? }.
export function createLeave(agentId, body) {
  return request({
    method: 'post',
    path: `/properties/agents/${agentId}/unavailability`,
    data: body,
  });
}

export function deleteLeave(agentId, leaveId) {
  return request({
    method: 'delete',
    path: `/properties/agents/${agentId}/unavailability/${leaveId}`,
  });
}
